// extracted by mini-css-extract-plugin
export default {"root":"IconFilledFavorite_root__+9T3a"};